export const iconFontAwesomeSecurityKey = (
	<i className="fa-solid fa-key"></i>
);
